import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
  Button,
  TextField,
  Tooltip, 
  IconButton,
} from '@mui/material'
import React, {useState} from 'react'
import {useAppSelector, useAppDispatch} from '../../../redux/storeExports'
import {
  selectAccountEmail,
  selectCompanyFederation,
  selectMuid,
} from 'shared/redux/authentication/authenticationSlice'
import ResetPassword from '../../Authentication/ResetPassword'
import {theme} from '../../../theme/DashboardTheme'
import {MfaCard} from '../../Authentication/MfaCard'
import DeleteAcc from './DeleteAcc'
import { redeemCodeForWeb, selectActiveGrant } from '../../../redux/product/ProductSlice'
import CopyIcon from 'shared/assets/icons/copyIcon.svg'

const heading = {
  color: '#3A155A',
  fontFamily: 'InterMedium',
  fontWeight: 500,
  marginBottom: 4,
  fontSize: '20px',
  lineHeight: '27px',
};

const styles = {
  heading,
  subHeading:{
    ...heading,
    fontSize: '16px',
    textTransform: 'uppercase',
  },
  bodyText:{
    fontFamily: 'InterRegular',
    fontWeight: 400,
    fontSize: '14px',
    color: '#6B7280',
  },
  button:{
    width: {xs: '100%', sm: '152px'},
    maxWidth: {xs:'152px', md: '300px'},
    height: 50,
    borderRadius: '10px',
    fontSize: {xs: '14px'}, 
    fontFamily: 'InterMedium',
    fontWeight: 500,
    background: '#9135E0',
    color: '#fff',
    '&.Mui-disabled': {
      background: '#9135E0',
      color: '#fff',
    },
    ':hover': {
      background: '#9135E0',
      color: '#fff',
    },
  },
  card: {
    height: '110px',
    borderRadius: '15px', 
    background: '#F7F8FA',
    paddingLeft: '16px',
    paddingRight: {xs: '10px', sm: '16px'},
    paddingTop: '26px',
    paddingBottom: '30px',
    boxShadow: 'none',
    marginBottom: 2,
   },
  cardTitle: {
    fontFamily: 'InterMedium', 
    fontWeight: 500,
    color: '#3A155A',
    fontSize: '18px',
  },
  cardContent: {
    color: '#6B7280',
    fontFamily: 'InterRegular', 
    fontWeight: 400,
    fontSize: '14px',
  },
  inputField:{
    width: '100%',
    backgroundColor: '#FFF',
    borderRadius: '10px',
    height: '50px',
    overflow: 'hidden',
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      height: '50px',
      '& fieldset': {
        border: '1.5px solid #E2E8F0',
      },
      '&:hover fieldset': {
        border: '1.5px solid #9135E0',
      },
      '&.Mui-focused fieldset': {
        border: '1.5px solid #9135E0',
      },
    },
    '& .MuiInputBase-input::placeholder': {
      color: '#A0AEC0',
      fontSize: '14px',
      fontWeight: 400,
      fontFamily: 'InterRegular',
    },
    '& .MuiInputBase-input': {
      color: '#3A155A',
      paddingLeft: '20px',
      fontFamily: 'InterRegular',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '140%',
    },
  }
}

const AccSecurity = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [code, setCode] = useState('')
  const accountEmail = useAppSelector(selectAccountEmail)
  const muid = useAppSelector(selectMuid)
  const dispatch = useAppDispatch()
  const companyFederation = useAppSelector(selectCompanyFederation)
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const grant = useAppSelector(selectActiveGrant)

  const handleCopy = () => {
    navigator.clipboard.writeText(muid as string);
    setTooltipOpen(true);
    setTimeout(() => {
      setTooltipOpen(false);
    }, 1000);
  };

  const mainComponent = () => {
    return (
      <Grid container columnSpacing={2.5} rowSpacing={2.5} padding={'16px 0'}>
        {!isMobile && (
          <Grid item xs={12} md={12}>
            <Typography 
              sx={styles.heading}
            >Account & Security</Typography>
          </Grid>
        )}
        <Grid item xs={12} md={5}>
          <Card sx={styles.card}>
            <CardContent sx={{padding: 0}}>
              <Typography sx={styles.cardTitle}>
                Sign in Email
              </Typography>
              <Box sx={{paddingBlockStart: '0.5rem'}}>
                <Typography sx={styles.cardContent}>
                  {accountEmail}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={7}>
          <Card sx={styles.card}>
            <CardContent sx={{padding: 0}}>
              <Grid container columnSpacing={5}>
                <Grid item xs={12}>
                  <Typography sx={styles.cardTitle}>
                    Priwall ID
                  </Typography>
                  <Box 
                    sx={{
                      paddingBlockStart: '0.5rem',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}>
                    <Typography sx={styles.cardContent}>
                      {muid}{' '}
                    </Typography>
                    <Tooltip
                      title="Copied!"
                      open={tooltipOpen}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      placement="top"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            fontFamily: 'InterRegular',
                            fontSize: '10px',
                            lineHeight: '16px',
                            fontWeight: 500,
                            color: '#ffffff',
                          },
                        },
                      }}
                    >
                    <IconButton onClick={handleCopy} sx={{ p: 0 }}>
                      <img
                        src={CopyIcon}
                        alt="Copy"
                        style={{ width: 24, height: 24 }}
                      />
                    </IconButton>
                  </Tooltip>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={12} xs={12}>
        </Grid>
        {!companyFederation && <ResetPassword/>}
        <Grid item md={12} xs={12}>
        </Grid>
        <MfaCard/>
        <Grid item md={12} xs={12}>
        </Grid>
        <Grid item
          md={12} xs={12}
              >
            <Typography sx={{...styles.subHeading, marginBottom: '10px'}}>
              Have a Code?
            </Typography>
        
            <Typography  sx={styles.bodyText}>
              Redeem Code
            </Typography>
            <Grid container columnGap={3.5} sx={{ width: '100%', alignItems: 'flex-end' }}>
              <Grid item md={3.5} xs={12} mt={2}>
                <TextField
                    sx={{
                        ...styles.inputField,
                        '& .MuiInputBase-input::placeholder': {
                          color: '#A0AEC0',
                          opacity: 1,
                          fontSize: '14px',
                          fontWeight: 400,
                          fontFamily: 'InterRegular',
                        }
                      }}
                      fullWidth
                      placeholder='Add code here...'
                      value={code}
                      onChange={(event) => setCode(event.target.value)}
                />
              </Grid>
              <Grid item md={4} xs={12} mt={'12px'}>
                <Button
                    sx={{
                    ...styles.button,
                    '&.Mui-disabled': {
                      opacity: 0.7, 
                      backgroundColor: '#9135E0',
                      color: '#fff',
                    },
                  }}
                  disabled={grant?.grant_source === 'corporate_grant'}
                    onClick={() => dispatch(redeemCodeForWeb(code))}>
                        Apply
                  </Button>
              </Grid>
            </Grid>
        </Grid>
        <Grid item md={12} xs={12}>
        </Grid>
        <DeleteAcc/>
      </Grid>
    )
  }
  return (
    <>
      {isMobile ? (
        mainComponent()
      ) : (
        <Card sx={{borderRadius: 5, overflow: 'auto', boxShadow: 'none', marginTop: 5}}>
          <CardContent>{mainComponent()}</CardContent>
        </Card>
      )}
    </>
  )
}

export default AccSecurity
